import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { AppModule } from './app/app.module';
import { Injector } from '@angular/core';
import {KeycloakService} from './app/login/keycloak.service';
import {GlobalsService} from './app/_services/globals.service';

if (environment.production) {
  enableProdMode();
}

var injector = Injector.create({ providers: [GlobalsService]});
var gsService = injector.get(GlobalsService)

//platformBrowserDynamic().bootstrapModule(AppModule);

KeycloakService.init()
   .then(() => {
    console.warn("BOOTSTRAPING...")
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .then((ref) => {
        console.log('BOOTSTRAP OK', ref);
        (window as any).__BOOTSTRAP_OK__ = true;
      })
      .catch((err) => {
        console.error('BOOTSTRAP FAILED', err);
        (window as any).__BOOTSTRAP_ERR__ = err;

        // Also stringify something readable:
        try {
          (window as any).__BOOTSTRAP_ERR_STR__ =
            err?.message + '\n' + (err?.stack || '');
        } catch {}
      });
  })
   .catch(e => {
    console.error("Keycloak init error:", e);
    
    (window as any).__KC_INIT_ERR__ = e;
    (window as any).__KC_INIT_ERR_STR__ =
      (e?.message || '') + '\n' + (e?.stack || '');
  });

// gsService.initConfig().subscribe(ok=>{
//     console.log(ok)
//     KeycloakService.init()
//     .then(() => {
//         platformBrowserDynamic().bootstrapModule(AppModule);
//     })
//     .catch((e) => {console.log(e);console.log("KeycloakService error");window.location.reload()});//window.location.reload());
    
// });

